import React, { Component } from 'react'
import '../styles/TeamBuilding.css'
import Navbar from './Navbar'
import FAQAnswer from './FAQAnswer'
import Field from './Field'
import Footer from './Footer'
import Select from 'react-select'
import DatePicker from './DatePicker'
import PopInConfirmation from './PopInConfirmation'
import moment from 'moment'
import 'moment/locale/fr'
import {Helmet} from "react-helmet"
import TBHero from '../images/TeamBuilding/tb-hero.png'
import TBPicture1 from '../images/TeamBuilding/tb-picture-1.png'
import TBPicture2 from '../images/TeamBuilding/tb-picture-2.png'
import CocktailIcon from '../images/TeamBuilding/cocktail-icon.png'
import CandyIcon from '../images/TeamBuilding/candy-icon.png'
import PaintIcon from '../images/TeamBuilding/paint-icon.png'
import CalendarIcon from '../images/TeamBuilding/calendar-icon.png'
import ClockIcon from '../images/TeamBuilding/clock-icon.png'
import CheckIcon from '../images/TeamBuilding/check-icon.png'
import ChartIcon from '../images/TeamBuilding/chart-icon.png'
import CoffeeIcon from '../images/TeamBuilding/coffee-icon.png'
import LunchIcon from '../images/TeamBuilding/lunch-icon.png'
import DinerIcon from '../images/TeamBuilding/cocktail-with-menu-icon.png'
import BtnPlaquette from '../images/TeamBuilding/btn_telecharger.jpg'
import Plaquette from '../images/TeamBuilding/teambuilding-onehour.pdf'
import { injectIntl, defineMessages } from "react-intl"
import axios from 'axios'
import { domain } from '../webURL'

const removeTransition = (element) => {
  element.classList.remove("site-transition--visible")
}

class TeamBuilding extends Component {
  constructor(props) {
    super(props)
    moment.locale('fr')
    this.state = {
      openAnswers: [],
      companyName: "",
      address: "",
      name: "",
      Lastname: "",
      email: "",
      phoneNumber: "",
      numberOfPlayers: "",
      date: moment(new Date()),
      hour: "",
      comment: "",
      workingRoom: false,
      breakfast: false,
      lunch: false,
      dinner: false,
      isTop: true,
      showPopin: false,
      price: "-"
    }

    this.props.getPrices([], false).then((output) => {
      this.setState({ price: output["prixteambuilding"] });
    })
    .catch((e) => {
      console.error(e);
    });
  }

  isToggled = (id) => {
    return this.state.openAnswers.includes(id)
  }

  testOpen = (id) => {
    if (this.state.openAnswers.includes(id)) {
      return "faq-answer faq-answer--open"
    } else {
      return "faq-answer"
    }
  }

  adjustContainerHeight = (id, direction) => {
    const container = document.getElementById("tb-content-container")
    const offset = container.offsetHeight
    const answerHeight = document.getElementById(`faq-answer-${id}`).offsetHeight
    const answerHeaderHeight = document.getElementById(`faq-answer-header-${id}`).offsetHeight
    let height = offset + direction * (answerHeight - answerHeaderHeight) + "px"
    container.style.height = height
  }

  openQuestion = (id) => {
    if (!this.state.openAnswers.includes(id)) {
      const answers = this.state.openAnswers
      answers.push(id)
      this.setState({ answers: answers })
      window.setTimeout(() => {
        this.adjustContainerHeight(id, 1)
      }, 500)

    } else if (this.state.openAnswers.includes(id)) {
      this.setState({
        openAnswers: this.state.openAnswers.filter(ids => ids !== id)
      }, this.adjustContainerHeight(id, -1))
    }
  }

  handleHour = (hour) => {
    this.setState({ hour: hour })
  }

  datePickerAnimation = () => {
    const label = document.getElementById("tb-form-date-picker").getElementsByClassName("form-field-label")[0]
    label.classList.add("form-field-label--active")

    const input = document.getElementById("tb-form-date-picker-input")
    input.innerHTML = this.state.date.format('L')
    input.classList.add("tb-form-date-picker-input--active")
  }

  changeDate = async (date) => {
    await this.setState({ date: date })
    this.datePickerAnimation()
  }

  sendForm = async () => {

    const htmlContent =
    `<h2>Nouvelle demande de devis TeamBuilding</h2>
    <table style="width:100%">
      <tr>
        <td>Société</td>
        <td>${this.state.companyName}</td>
      </tr>
      <tr>
        <td>Adresse</td>
        <td>${this.state.address}</td>
      </tr>
      <tr>
        <td>Nom</td>
        <td>${this.state.name}</td>
      </tr>
      <tr>
        <td>Prénom</td>
        <td>${this.state.Lastname}</td>
      </tr>
      <tr>
        <td>Email</td>
        <td>${this.state.email}</td>
      </tr>
      <tr>
        <td>Téléphone</td>
        <td>${this.state.phoneNumber}</td>
      </tr>
      <tr>
        <td>Nombre de participants</td>
        <td>${this.state.numberOfPlayers}</td>
      </tr>
      <tr>
        <td>Date souhaitée</td>
        <td>${moment(this.state.date).format('LL')}</td>
      </tr>
      <tr>
        <td>Horaire souhaité</td>
        <td>${this.state.hour}</td>
      </tr>
      <tr>
        <td>Commentaire</td>
        <td>${this.state.comment}</td>
      </tr>
      <tr>
        <td>Salle de travail</td>
        <td>${this.state.workingRoom ? "oui" : "non"}</td>
      </tr>
      <tr>
        <td>Petit-Déjeuner</td>
        <td>${this.state.breakfast ? "oui" : "non"}</td>
      </tr>
      <tr>
        <td>Déjeuner</td>
        <td>${this.state.lunch ? "oui" : "non"}</td>
      </tr>
      <tr>
        <td>Diner</td>
        <td>${this.state.dinner ? "oui" : "non"}</td>
      </tr>
    </table>`

    
    return await axios({
        method: 'POST',
        url: 'https://services.' + domain + '/SendContactMail.php',
        headers: {accept: 'application/json','content-type': 'application/json'},
        data: '{"subject":"Demande de devis Teambuilding","htmlContent":'+JSON.stringify(htmlContent)+'}'
    })
    .then(response => {
      console.log(response.data)
    })
    .catch(error => console.log(error))
  }

  validateForm = () => {
    let inputs = document.getElementsByClassName("form-field-input")
    Array.prototype.forEach.call(inputs, (el) => {
      if (el.required && el.value === "") {
        el.classList.add("form-field-input--error")
      } else {
        el.classList.remove("form-field-input--error")
      }
    })

    return document.getElementsByClassName("form-field-input--error").length === 0
  }

  submitForm = () => {
    if (this.validateForm()) {
      this.sendForm()
      this.setState({ showPopin: true })
    }
  }

  componentDidMount() {
    document.addEventListener('scroll', () => {
      const isTop = window.scrollY < 100;
      if (isTop !== this.state.isTop) {
          this.setState({ isTop })
      }
    })

    const glitchTransition = document.getElementById("site-transition")
    window.setTimeout(() => {
      glitchTransition.classList.add("site-transition--visible")
      window.setTimeout(() => {
        removeTransition(glitchTransition)
      }, 500)
    }, 10)
  }

  render() {
    const {intl:{formatMessage}} = this.props
    const hourLabelStyle = this.state.hour === ""
      ? "hour-select-label"
      : "hour-select-label hour-select-label--selected"

    return (
     <div className="tb" id="tb">
      <Helmet>
        <title>Team Building escape game Paris - One Hour</title>
        <meta name="description" content="Team building Escape Game à Paris : offres entreprise dans l'enseigne numéro 1 Tripadvisor. La solution idéale pour une sortie en cohésion d'équipe."/>
      </Helmet>
      <Navbar
        isTop={this.state.isTop}
        lang={this.props.lang}
        handleLang={(lang) => this.props.handleLang(lang)}/>
      <div className="tb-hero" style={{ backgroundImage: `url(${TBHero})`}}>
        <div className="tb-hero-title">
          <h1>{formatMessage(messages.title1)}</h1>
          <p>{formatMessage(messages.title2)}</p>
        </div>
      </div>
      <div id="tb-content-container" className="tb-content-container">
        <div className="tb-content">
          <h3>{formatMessage(messages.introTitle)}</h3>
          <p>{formatMessage(messages.introText)}</p>
            <div className="tb-ticket">{formatMessage(messages.pricingText)} <br /> <span> {this.state.price} &euro; HT / personne</span></div>
          <div className="tb-content-block">
            <div className="tb-content-block-text">
              <p>{formatMessage(messages.content1)} <b>{formatMessage(messages.contentBold1)}</b>, {formatMessage(messages.content2)} <b>{formatMessage(messages.contentBold2)}</b>.</p>
              <p>{formatMessage(messages.content3)}</p>
            </div>
            <div style={{ backgroundImage: `url(${TBPicture1})`}} className="tb-content-block-image" />
          </div>
		  <div className="tb-content-block">
		    <a 
			  rel="noopener noreferrer" 
			  href={`${Plaquette}`} 
			  target="_blank"
			  className="linkbtn">
			  <div style={{ backgroundImage: `url(${BtnPlaquette})`}} className="tb-content-block-dl" />
			</a>
		  </div>
          <div className="tb-content-block">
            <div style={{ backgroundImage: `url(${TBPicture2})`}} className="tb-content-block-image" />
            <div className="tb-content-block-text">
              <p>{formatMessage(messages.customization)}</p>
              <p>{formatMessage(messages.including)}</p>
              <ul>
                <li>
                  <div className="tb-content-block-icon" style={{ backgroundImage: `url(${CocktailIcon})`}}/>
                  <p><b>{formatMessage(messages.includedDrinksBold)}</b> {formatMessage(messages.includedDrinks)}</p>
                </li>
                <li>
                  <div className="tb-content-block-icon" style={{ backgroundImage: `url(${CandyIcon})`}}/>
                  <p><b>{formatMessage(messages.includedCandiesBold)}</b> {formatMessage(messages.includedCandies)}</p>
                </li>
                <li>
                  <div className="tb-content-block-icon" style={{ backgroundImage: `url(${PaintIcon})`}}/>
                  <p><b>{formatMessage(messages.includedCustomizationBold)}</b> {formatMessage(messages.includedCustomization)}</p>
                </li>
              </ul>
            </div>
          </div>
          <h2>{formatMessage(messages.howThingsWork)}</h2>
          <div className="tb-toggle-list">
              <p>{formatMessage(messages.questions3to5_1)}</p>
              <p>
              {formatMessage(messages.questions3to5_2)}<br />
              {formatMessage(messages.questions3to5_3)}<br />
              {formatMessage(messages.questions3to5_4)}<br />
              {formatMessage(messages.questions3to5_5)}
              </p>
          </div>
          <h2>{formatMessage(messages.quoteTitle)}</h2>
            <p>{formatMessage(messages.quoteText)}<br />{formatMessage(messages.quoteText2)} <b>{this.state.price} &euro; HT / personne</b>.</p>
          <form className="tb-form" id="tb-form">
            <h3>{formatMessage(messages.formCompanyTitle)}</h3>
            <Field
              name="company_name"
              required={true}
              placeholder={formatMessage(messages.formCompanyName)}
              onChange={(data) => this.setState({ companyName: data})}/>
            <Field
              name="address"
              required={true}
              placeholder={formatMessage(messages.formAddress)}
              onChange={(data) => this.setState({ address: data})}/>
            <Field
              name="lname"
              required={true}
              placeholder={formatMessage(messages.formName)}
              onChange={(data) => this.setState({ name: data})}/>
            <Field
              name="Lastname"
              required={true}
              placeholder={formatMessage(messages.formLastname)}
              onChange={(data) => this.setState({ Lastname: data})}/>
            <Field
              name="email"
              required={true}
              placeholder={formatMessage(messages.formCompanyEmail)}
              onChange={(data) => this.setState({ email: data})}
              email />
            <Field
              name="phone"
              required={true}
              placeholder={formatMessage(messages.formCompanyPhone)}
              onChange={(data) => this.setState({ phoneNumber: data})}/>
            <h3>{formatMessage(messages.formServiceTitle)}</h3>
            <Field
              number
              name="number_of_players"
              required={true}
              placeholder={formatMessage(messages.formNumberOfPlayers)}
              onChange={(data) => this.setState({ numberOfPlayers: data})}/>
            <div className="tb-form-row">
              <div className="tb-form-cell" id="tb-form-date-picker">
                <Field
                  placeholder={formatMessage(messages.formDate)}
                  onChange={(data) => this.setState({ date: data})}/>
                  <DatePicker
                    date={this.state.date}
                    handleChange={ date => this.changeDate(date)}
                    selectedTheme="all"
                    klass="date-picker--tb"
                    />
                <span id="tb-form-date-picker-input"></span>
                <img src={CalendarIcon} alt=""/>
              </div>
              <div className="tb-form-cell tb-select-hour">
                <Select
                  name="hour"
                  value={this.state.hour}
                  onChange={(e) => this.handleHour(e.value)}
                  className={"hour-select"}
                  searchable={false}
                  clearable={false}
                  placeholder={""}
                  options={[
                    { value: '10h-12h', label: '10h', className: 'hour-select-option' },
                    { value: '12h-14h', label: '12h', className: 'hour-select-option' },
                    { value: '14h-16h', label: '14h', className: 'hour-select-option' },
                    { value: '16h-18h', label: '16h', className: 'hour-select-option' },
                    { value: '18h-20h', label: '18h', className: 'hour-select-option' },
                    { value: '20h-22h', label: '20h', className: 'hour-select-option' },
                    { value: '22h-00h', label: '22h', className: 'hour-select-option' }
                  ]}
                />
                <span className={hourLabelStyle}>{formatMessage(messages.formSlot)}</span>
                <img src={ClockIcon} alt=""/>
              </div>
            </div>
            <Field textarea
              name="comment"
              placeholder={formatMessage(messages.formComment)}
              onChange={(data) => this.setState({ comment: data})} />
            <h4>{formatMessage(messages.formOptionsTitle)}</h4>
            <div className="tb-options-container">
              <div
                id ="tb-option-1"
                className={this.state.workingRoom ? "tb-option tb-option--selected" : "tb-option"}
                onClick={() => this.setState({ workingRoom: !this.state.workingRoom})}>
                <img className="tb-option-check" src={CheckIcon} alt=""/>
                <div className="tb-option-icon" style={{ backgroundImage: `url(${ChartIcon})`}}/>
                <span>{formatMessage(messages.formOptionsWorkingRoom)}</span>
              </div>
              <div
                id ="tb-option-2"
                className={this.state.breakfast ? "tb-option tb-option--selected" : "tb-option"}
                onClick={() => this.setState({ breakfast: !this.state.breakfast})}>
                <img className="tb-option-check" src={CheckIcon} alt=""/>
                <div className="tb-option-icon" style={{ backgroundImage: `url(${CoffeeIcon})`}}/>
                <span>{formatMessage(messages.formOptionsBreakfast)}</span>
              </div>
              <div
                id ="tb-option-3"
                className={this.state.lunch ? "tb-option tb-option--selected" : "tb-option"}
                onClick={() => this.setState({ lunch: !this.state.lunch})}>
                <img className="tb-option-check" src={CheckIcon} alt=""/>
                <div className="tb-option-icon" style={{ backgroundImage: `url(${LunchIcon})`}}/>
                <span>{formatMessage(messages.formOptionsLunch)}</span>
              </div>
              <div
                id ="tb-option-4"
                className={this.state.dinner ? "tb-option tb-option--selected" : "tb-option"}
                onClick={() => this.setState({ dinner: !this.state.dinner})}>
                <img className="tb-option-check" src={CheckIcon} alt=""/>
                <div className="tb-option-icon" style={{ backgroundImage: `url(${DinerIcon})`}}/>
                <span>{formatMessage(messages.formOptionsDiner)}</span>
              </div>
            </div>
            <div className="tb-form-cta" onClick={() => this.submitForm()}>
              {formatMessage(messages.formSubmit)}
            </div>
          </form>
        </div>
      </div>
      <Footer />
      {
        this.state.showPopin
        ? <PopInConfirmation closePopIn={() => this.setState({ showPopin: false }, window.location.reload())} />
        : null
      }
     </div>
    )
  }
}

const messages = defineMessages({
  title1: {
    id: 'tb.title1',
    defaultMessage: 'Team Building Escape Game Paris'
  },
  title2: {
    id: 'tb.title2',
    defaultMessage: "L'union fait le lol"
  },
  introTitle: {
    id: 'tb.introTitle',
    defaultMessage: 'L’escape game est le jeu d’équipe idéal pour un Team Building !'
  },
  introText: {
    id: 'tb.introText',
    defaultMessage: 'Répartis en équipes, vous devrez faire appel à votre sens de l’observation, à votre logique et surtout à votre esprit d’équipe afin de vous échapper d’une de nos pièce à thème en moins d’une heure !'
  },
  pricingText: {
    id: 'tb.pricingText',
    defaultMessage: "Notre prestation entreprise est à"
  },
  pricing: {
    id: 'tb.pricing',
    defaultMessage: "40€ / personne"
  },
  content1: {
    id: 'tb.content1',
    defaultMessage: "Idéalement situé dans le onzième arrondissement de Paris, l’escape game One Hour vous réservera"
  },
  content2: {
    id: 'tb.content2',
    defaultMessage: "et personnalisera votre expérience afin de faire de votre team building escape game Paris un"
  },
  content3: {
    id: 'tb.content3',
    defaultMessage: "Nous proposons actuellement quatre salles d’Escape Game qui peuvent chacune accueillir jusqu’à 5 personnes : Lost Asylum, Very Bad Night, l’Abattoir et Mission Yakuza."
  },
  contentBold1: {
    id: 'tb.contentBold1',
    defaultMessage: "un accueil agréable dans un cadre décontracté"
  },
  contentBold2: {
    id: 'tb.contentBold2',
    defaultMessage: "moment inoubliable"
  },
  customization: {
    id: 'tb.customization',
    defaultMessage: "One Hour personnalise ses salles et ses énigmes pour vous offrir un team building escape game qui VOUS ressemble ! "
  },
  including: {
    id: 'tb.including',
    defaultMessage: "Notre offre comprend : "
  },
  includedDrinksBold: {
    id: 'tb.includedDrinksBold',
    defaultMessage: "Boissons froides et chaudes"
  },
  includedDrinks: {
    id: 'tb.includedDrinks',
    defaultMessage: "à volonté"
  },
  includedCandiesBold: {
    id: 'tb.includedCandiesBold',
    defaultMessage: "Bonbons"
  },
  includedCandies: {
    id: 'tb.includedCandies',
    defaultMessage: "à volonté"
  },
  includedCustomizationBold: {
    id: 'tb.includedCustomizationBold',
    defaultMessage: "Personnalisation"
  },
  includedCustomization: {
    id: 'tb.includedCustomization',
    defaultMessage: "de la salle"
  },
  howThingsWork: {
    id: 'tb.howThingsWork',
    defaultMessage: "Déroulement de la prestation"
  },
  questions3to5: {
    id: 'tb.questions3to5',
    defaultMessage: "De 3 à 5 personnes"
  },
  questions6to10: {
    id: 'tb.questions6to10',
    defaultMessage: "De 6 à 10 personnes"
  },
  questions10to20: {
    id: 'tb.questions10to20',
    defaultMessage: "De 10 à 20 personnes"
  },
  questions15to20: {
    id: 'tb.questions15to20',
    defaultMessage: "De 15 à 20 personnes"
  },
  questions3to5_1: {
    id: 'tb.questions3to5_1',
    defaultMessage: "Choix du thème de votre choix lors de la réservation puis,  pour une session à 18H :"
  },
  questions3to5_2: {
    id: 'tb.questions3to5_2',
    defaultMessage: "18H00 : arrivée dans les locaux. Boissons d’accueil et bonbons à volonté."
  },
  questions3to5_3: {
    id: 'tb.questions3to5_3',
    defaultMessage: "18H05 : présentation des salles et briefing personnalisé"
  },
  questions3to5_4: {
    id: 'tb.questions3to5_4',
    defaultMessage: "18H15 : début des parties personnalisées"
  },
  questions3to5_5: {
    id: 'tb.questions3to5_5',
    defaultMessage: "19H15 : fin de la partie et débriefing personnalisé avec photo"
  },
  questions6to10_1: {
    id: 'tb.questions6to10_1',
    defaultMessage: "Division des joueurs en 2 équipes. Chaque équipe se répartira sur un thème différent. Pour une session à 18H :"
  },
  questions6to10_2: {
    id: 'tb.questions6to10_2',
    defaultMessage: "18H : arrivée des deux équipes dans les locaux.Boissons d’accueil et bonbons à volonté."
  },
  questions6to10_3: {
    id: 'tb.questions6to10_3',
    defaultMessage: "18H05 : présentation des salles, répartition des équipes et briefing personnalisé"
  },
  questions6to10_4: {
    id: 'tb.questions6to10_4',
    defaultMessage: "18H15 : début des parties personnalisées"
  },
  questions6to10_5: {
    id: 'tb.questions6to10_5',
    defaultMessage: "19H15 : fin de la partie et débriefing personnalisé avec photo"
  },
  questions10to20_1: {
    id: 'tb.questions10to20_1',
    defaultMessage: "A partir de 10 personnes, vous devrez constituer 3 ou 4 équipes de 5 personnes maximum"
  },
  questions10to20_2: {
    id: 'tb.questions10to20_2',
    defaultMessage: "Déroulement de la prestation (pour une session de 20 personnes à 18H)"
  },
  questions10to20_3: {
    id: 'tb.questions10to20_3',
    defaultMessage: "18H : arrivée des deux premières équipes dans les locaux. Boissons d’accueil et bonbons à volonté."
  },
  questions10to20_4: {
    id: 'tb.questions10to20_4',
    defaultMessage: "18H05 : présentation des salles et briefing personnalisé"
  },
  questions10to20_5: {
    id: 'tb.questions10to20_5',
    defaultMessage: "18H15 : début des parties personnalisées"
  },
  questions10to20_6: {
    id: 'tb.questions10to20_6',
    defaultMessage: "19H15 : fin de la partie et débriefing personnalisé avec photo"
  },
  questions10to20_7: {
    id: 'tb.questions10to20_7',
    defaultMessage: "19H40 : arrivée de la troisième et quatrième équipe. Boissons et collations d’accueil."
  },
  questions10to20_8: {
    id: 'tb.questions10to20_8',
    defaultMessage: "19H45 : présentation des salles et briefing personnalisé"
  },
  questions10to20_9: {
    id: 'tb.questions10to20_9',
    defaultMessage: "19H55 : début des parties personnalisées. Les deux premières équipes peuvent si elles le souhaitent s’installer dans un espace prévu à cet effet afin d’observer les progression des nouvelles équipes."
  },
  questions10to20_10: {
    id: 'tb.questions10to20_10',
    defaultMessage: "20H55 : fin de la partie et débriefing personnalisé avec photo"
  },
  questions15to20_1: {
    id: 'tb.questions15to20_1',
    defaultMessage: "A partir de 15 personnes, vous devrez constituer 4 équipes de 5 personnes maximum, et vous répartir parmi nos quatre thèmes."
  },
  questions15to20_2: {
    id: 'tb.questions15to20_2',
    defaultMessage: "Déroulement de la prestation (pour une session de 20 personnes à 18H)"
  },
  questions15to20_3: {
    id: 'tb.questions15to20_3',
    defaultMessage: "18H : arrivée des deux premières équipes dans les locaux. Boissons d’accueil et bonbons à volonté."
  },
  questions15to20_4: {
    id: 'tb.questions15to20_4',
    defaultMessage: "18H05 : présentation des salles et briefing personnalisé"
  },
  questions15to20_5: {
    id: 'tb.questions15to20_5',
    defaultMessage: "18H15 : début des parties personnalisées"
  },
  questions15to20_6: {
    id: 'tb.questions15to20_6',
    defaultMessage: "19H15 : fin de la partie et débriefing personnalisé avec photo"
  },
  questions15to20_7: {
    id: 'tb.questions15to20_7',
    defaultMessage: "19H40 : arrivée de la troisième et quatrième équipe. Boissons et collations d’accueil."
  },
  questions15to20_8: {
    id: 'tb.questions15to20_8',
    defaultMessage: "19H45 : présentation des salles et briefing personnalisé"
  },
  questions15to20_9: {
    id: 'tb.questions15to20_9',
    defaultMessage: "19H55 : début des parties personnalisées. Les deux premières équipes peuvent si elles le souhaitent s’installer dans un espace prévu à cet effet afin d’observer les progression des nouvelles équipes."
  },
  questions15to20_10: {
    id: 'tb.questions15to20_10',
    defaultMessage: "20H55 : fin de la partie et débriefing personnalisé avec photo"
  },
  quoteTitle: {
    id: 'tb.quoteTitle',
    defaultMessage: "Demande de devis"
  },
  quoteText: {
    id: 'tb.quoteText',
    defaultMessage: "N’hésitez pas à remplir le formulaire ci-dessous pour obtenir un devis."
  },
  quoteText2: {
    id: 'tb.quoteText2',
    defaultMessage: "Notre prestation entreprise est à "
  },
  quoteText2Bold: {
    id: 'tb.quoteText2Bold',
    defaultMessage: "40€/personne"
  },
  formCompanyTitle: {
    id: 'tb.formCompanyTitle',
    defaultMessage: "Informations sur la société"
  },
  formCompanyName: {
    id: 'tb.formCompanyName',
    defaultMessage: "Société*"
  },
  formAddress: {
    id: 'tb.formAddress',
    defaultMessage: "Adresse*"
  },
  formName: {
    id: 'tb.formName',
    defaultMessage: "Nom*"
  },
   formLastname: {
    id: 'tb.formLastname',
    defaultMessage: "Prénom*"
  },
  formCompanyEmail: {
    id: 'tb.formCompanyEmail',
    defaultMessage: "Email*"
  },
  formCompanyPhone: {
    id: 'tb.formCompanyPhone',
    defaultMessage: "Téléphone*"
  },
  formServiceTitle: {
    id: 'tb.formServiceTitle',
    defaultMessage: "Informations sur la prestation souhaitée :"
  },
  formNumberOfPlayers: {
    id: 'tb.formNumberOfPlayers',
    defaultMessage: "Nombre de participants*"
  },
  formDate: {
    id: 'tb.formDate',
    defaultMessage: "Date souhaitée*"
  },
  formSlot: {
    id: 'tb.formSlot',
    defaultMessage: "Horaire souhaité*"
  },
  formComment: {
    id: 'tb.formComment',
    defaultMessage: "Commentaire (facultatif)"
  },
  formOptionsTitle: {
    id: 'tb.formOptionsTitle',
    defaultMessage: "Options (cumulables) :"
  },
  formOptionsWorkingRoom: {
    id: 'tb.formOptionsWorkingRoom',
    defaultMessage: "Salle de travail"
  },
  formOptionsBreakfast: {
    id: 'tb.formOptionsBreakfast',
    defaultMessage: "Petit Déjeuner"
  },
  formOptionsLunch: {
    id: 'tb.formOptionsLunch',
    defaultMessage: "Déjeuner"
  },
  formOptionsDiner: {
    id: 'tb.formOptionsDiner',
    defaultMessage: "Diner"
  },
  formSubmit: {
    id: 'tb.formSubmit',
    defaultMessage: "Envoyer ma demande"
  },
})

export default injectIntl(TeamBuilding)




// WEBPACK FOOTER //
// ./src/components/TeamBuilding.js